import VoIPProvider, { useVoIP } from './Provider';

const VoIPWrapper = (props) => {
    return <VoIPProvider {...props}>
        {props.children}
    </VoIPProvider>
};

export default VoIPWrapper;

export {
    useVoIP,
}
